import { BooleanRolloverAttribute } from './parser.types';

export const cell = {
  readOnly: true,
  value: '',
};
export const KEEP_MARKET_DATA = 'keepMarketData';
export const ATTRIBUTE_KEYS: BooleanRolloverAttribute[] = [
  KEEP_MARKET_DATA,
  'excludeValuation',
  'resetFinancials',
  'excludeDocuments',
];
